import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ContactsPage from "../pages/contacts/page";
import CarportsPage from "../pages/carports/page";
import GazebosPage from "../pages/gazebos/page";
import GatesPage from "../pages/gates/page";
import BbqPage from "../pages/bbq/page";
import GraveFencesPage from "../pages/grave-fences/page";
import RailingsPage from "../pages/railings/page";
import FireplaceSetsPage from "../pages/fireplace-sets/page";
import WindowGrillesPage from "../pages/window-grilles/page";
import SwingsPage from "../pages/swings/page";
import BenchesPage from "../pages/benches/page";
import WroughtFurniturePage from "../pages/wrought-furniture/page";
import PrivacyPolicyPage from "../pages/privacy-policy/page";
import DataPolicyPage from "../pages/data-policy/page";
import CanopiesPage from "../pages/canopies/page";
import ProductCityPage from "../pages/product-city/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products/carports",
    element: <CarportsPage />,
  },
  {
    path: "/products/canopies",
    element: <CanopiesPage />,
  },
  {
    path: "/products/:productSlug/:citySlug",
    element: <ProductCityPage />,
  },
  {
    path: "/products/gazebos",
    element: <GazebosPage />,
  },
  {
    path: "/products/gates",
    element: <GatesPage />,
  },
  {
    path: "/products/bbq",
    element: <BbqPage />,
  },
  {
    path: "/products/grave-fences",
    element: <GraveFencesPage />,
  },
  {
    path: "/products/railings",
    element: <RailingsPage />,
  },
  {
    path: "/products/fireplace-sets",
    element: <FireplaceSetsPage />,
  },
  {
    path: "/products/window-grilles",
    element: <WindowGrillesPage />,
  },
  {
    path: "/products/swings",
    element: <SwingsPage />,
  },
  {
    path: "/products/benches",
    element: <BenchesPage />,
  },
  {
    path: "/products/wrought-furniture",
    element: <WroughtFurniturePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contacts",
    element: <ContactsPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/data-policy",
    element: <DataPolicyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;